/* D1 — Scrolling banner reagiert auf das Scrollen der Seite.
   Eingebunden aus sections/scrolling-banner.liquid (nur wenn der Modus nicht "Aus" ist).
   Die Marquee bleibt die CSS-Animation des Themes (main.css @keyframes marquee); hier wird
   ausschließlich deren playbackRate verändert — nie play()/pause(), sonst greift
   "Pause bei Hover" (animation-play-state) nicht mehr. */
(() => {
  if (window.D1ScrollBanner) return;
  window.D1ScrollBanner = true;

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const visible = new Set();
  const states = new WeakMap();
  // Rückwärts kann eine CSS-Animation nicht vor Zeit 0 laufen und bliebe dort stehen.
  // Deshalb die Zeit um ganze Durchläufe nach vorn schieben — optisch ohne Sprung.
  const HEADROOM_MS = 1e9;

  let generation = 0;
  let running = false;
  let lastY = window.scrollY;
  let lastT = 0;
  let velocity = 0; // px/s, geglättet

  const stateFor = (el) => {
    let s = states.get(el);
    if (!s) {
      s = { rate: 1, sign: 1, anims: [], base: 0, gen: -1 };
      states.set(el, s);
    }
    return s;
  };

  const collect = (el, s) => {
    s.gen = generation;
    s.anims = el.getAnimations({ subtree: true }).filter((a) => a.animationName === 'marquee');
    s.base = 0;
    if (!s.anims.length) return;
    const items = s.anims[0].effect.target;
    const durationMs = s.anims[0].effect.getComputedTiming().duration;
    if (!items || !durationMs || !items.offsetWidth) return;
    s.base = items.offsetWidth / (durationMs / 1000); // px/s bei Normaltempo
    const now = s.anims[0].currentTime || 0;
    if (now < HEADROOM_MS / 2) {
      const shift = Math.ceil(HEADROOM_MS / durationMs) * durationMs;
      s.anims.forEach((a) => { a.currentTime = (a.currentTime || 0) + shift; });
    }
    s.anims.forEach((a) => { a.playbackRate = s.rate; });
  };

  const apply = (s, rate) => {
    if (rate === s.rate) return;
    s.rate = rate;
    s.anims.forEach((a) => { a.playbackRate = rate; });
  };

  const tick = (now) => {
    const dt = lastT ? Math.min((now - lastT) / 1000, 0.1) : 1 / 60;
    lastT = now;
    const y = window.scrollY;
    const dy = y - lastY;
    lastY = y;
    const instant = dt > 0 ? dy / dt : 0;
    velocity += (instant - velocity) * (1 - Math.exp(-dt / 0.03));
    if (Math.abs(velocity) < 1) velocity = 0;

    let busy = velocity !== 0;

    visible.forEach((el) => {
      if (!el.isConnected) { visible.delete(el); return; }
      const s = stateFor(el);
      if (s.gen !== generation || !s.anims.length || s.anims[0].playState === 'idle') collect(el, s);
      if (!s.anims.length || !s.base) return;

      if (el.dataset.d1Scroll === 'direction' && Math.abs(dy) > 2) s.sign = dy > 0 ? 1 : -1;
      // Handy: schnellere Wischer, schmaleres Band — Effekt mit der Breite skalieren
      const scale = Math.min(1, window.innerWidth / 1024);
      const strength = ((parseFloat(el.dataset.d1ScrollStrength) || 3) / 10) * scale;
      const extra = Math.min(Math.abs(velocity) * strength, 3000 * scale); // zusätzliche px/s
      const target = s.sign * (1 + extra / s.base);

      // Nachlauf (Einstellung, ms): Auslaufen mit dieser Zeitkonstante, Anziehen viermal so schnell. 0 = ohne Puffer
      const buffer = parseFloat(el.dataset.d1ScrollBuffer);
      const tauDown = (Number.isNaN(buffer) ? 0 : Math.max(buffer, 0)) / 1000;
      const up = Math.abs(target) > Math.abs(s.rate) || target * s.rate < 0;
      const tau = up ? tauDown / 4 : tauDown;
      const ease = tau > 0 ? 1 - Math.exp(-dt / tau) : 1;
      let rate = s.rate + (target - s.rate) * ease;
      if (Math.abs(target - rate) < 0.02) rate = target;
      else busy = true;
      apply(s, rate);
    });

    if (busy) requestAnimationFrame(tick);
    else { running = false; lastT = 0; }
  };

  const wake = () => {
    if (running || reduce.matches || !visible.size) {
      if (!running) lastY = window.scrollY;
      return;
    }
    running = true;
    requestAnimationFrame(tick);
  };

  const io = new IntersectionObserver((entries) => {
    entries.forEach(({ target, isIntersecting }) => {
      if (isIntersecting) { visible.add(target); return; }
      visible.delete(target);
      const s = states.get(target);
      if (s && s.anims.length) apply(s, s.sign); // außerhalb des Bilds sofort auf Normaltempo
    });
  }, { rootMargin: '100px 0px' });

  const scan = () => {
    document.querySelectorAll('.scrolling-banner[data-d1-scroll]').forEach((el) => io.observe(el));
  };

  scan();
  window.addEventListener('scroll', wake, { passive: true });
  window.addEventListener('resize', () => { generation += 1; }, { passive: true });
  document.addEventListener('shopify:section:load', () => { generation += 1; scan(); });
})();
